import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";
import { buildingOverallComplianceColor } from "common/constant";

const OverallComplianceBarChart = ({ t, nonComplianceBuildingData }) => {
  const initialOption = {
    chart: {
      type: "bar",
      stacked: true,
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + "%";
      },
      style: {
        fontSize: "13px",
        fontWeight: 900,
      },
    },

    xaxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
        trim: true,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },

    legend: {
      onItemHover: {
        highlightDataSeries: false,
      },
    },
    colors: buildingOverallComplianceColor,
  };

  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState(initialOption);

  useEffect(() => {
    const buildingData = {};
    nonComplianceBuildingData.forEach((record) => {
      const buildingRecord = record.buildingRecords[0];
      const buildingName = buildingRecord.buildingName;
      const compliance = buildingRecord.compliance;
      if (!buildingData[buildingName]) {
        buildingData[buildingName] = compliance;
      }
    });
    const categories = Object.keys(buildingData);
    const compliance = categories.map((category) => buildingData[category]);

    setSeries([{ name: "Compliance", data: compliance }]);

    setOptions((prev) => ({
      ...prev,
      xaxis: { ...prev.xaxis, categories },
    }));
  }, [nonComplianceBuildingData]);

  return (
    <Card className="p-0">
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="subtitle1" fontWeight={700}>
                {t("Building Overall Compliance Status")}
              </Typography>
            </Grid>
          </Grid>
        }
        className="border-bottom"
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={450}
        />
      </CardContent>
    </Card>
  );
};

OverallComplianceBarChart.propTypes = {
  nonComplianceBuildingData: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(OverallComplianceBarChart);
